export default __webpack_public_path__ + "static/media/green-sun.944abbd4.jpg";